<template>
  <div class="box">
    <div class="box-header">
      <h3 class="box-title">People</h3>
      <p>W:500px x H:500px</p>
    </div>
    <div class="grids is-3-desktop gap-20-desktop">
      <input
        hidden="hidden"
        name="image"
        ref="fileinputPeople"
        type="file"
        @input="onSelectFilePeople"
      />
      <div class="person" v-for="(info, index) in people" :key="index">
        <i class="fa-solid fa-trash" @click="people.splice(index, 1)"></i>
        <div class="person-photo">
          <img
            :src="$urlImageShow + 'assistant-logo/avatar.png'"
            @click="uploadPeopleFile(index)"
            alt=""
            v-if="!people[index].image"
          />
          <img
            :src="$urlImageShow + people[index].image"
            @click="uploadPeopleFile(index)"
            alt=""
            v-else
          />
        </div>
        <div class="person-info">
          <input hidden="hidden" name="image" v-model="people" type="text" />
          <input
            type="text"
            class="input"
            v-model="people[index].video"
            placeholder="Video link"
          />
          <input
            type="text"
            class="input"
            v-model="people[index].name"
            placeholder="Name"
          />
          <input
            type="text"
            class="input"
            v-model="people[index].position"
            placeholder="Position"
          />
          <textarea
            class="textarea"
            id=""
            cols="30"
            rows="3"
            v-model="people[index].duty"
            placeholder="Duty"
          ></textarea>
        </div>
      </div>
      <div class="add" @click="People()"><i class="fa-light fa-plus"></i></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["isPeople"],
  data() {
    return {
      imageDataPeople: null,
      people: [],
      bIdx: null,
    };
  },
  watch: {
    people: {
      handler(val) {
        this.$emit("input", val);
      },
      immediate: true,
      deep: true,
    },
    isPeople() {
      this.people = this.isPeople;
    },
  },
  methods: {
    People() {
      this.people.push({
        image: "",
        video: "",
        name: "",
        position: "",
        duty: "",
      });
    },
    uploadPeopleFile(idx) {
      this.bIdx = idx;
      this.$refs.fileinputPeople.click();
    },
    async onSelectFilePeople() {
      const input = this.$refs.fileinputPeople;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          this.errorfileSize = file.name;
          axios.defaults.headers.common[
            "Authorization"
          ] = this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImage}`, formData);
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.people = null;
            this.imageDataPeople = null;
          }
          if (res.data.fileKey) {
            this.errorfileSize = file.name;
            // this.namePeople.push(res.data.file.name)
            // this.data.file2.push(res.data.file)
            this.people[this.bIdx].image = res.data.fileKey;

            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.imageDataPeople = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
          // console.log(res.data.file.size)
        } else {
          this.errorfileSize = "The file Size is too much";
          this.imageDataPeople = null;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.person {
  border: 1px solid var(--border-color);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  i {
    cursor: pointer;
    top: 0;
    right: 0;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 0 0 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--alert-color-rgb), 0.1);
    color: var(--alert-color);
  }

  .person-photo {
    img {
      max-height: 180px;
      max-width: 180px;
      min-height: 180px;
      min-width: 180px;
      border-radius: 180px;
      display: block;
    }
  }

  .person-info {
    margin-top: 20px;

    input {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}

.add {
  min-height: 180px;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(var(--primary-color-rgb), 0.05);
  border: 1px solid var(--primary-color);

  i {
    color: var(--primary-color);
    font-size: var(--xxlg-font);
  }
}
</style>
